import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-20px font-montserrat font-semibold p-4" }, " Status Klaim ", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-2 px-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_3 = { class: "font-montserrat text-14px font-semibold" }
const _hoisted_4 = { class: "font-montserrat font-normal pb-4 text-13px" }
const _hoisted_5 = { id: "tnc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_component_Card, { class: "pb-4" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_Timeline, {
        value: _ctx.sortingArray,
        align: "left",
        class: "customized-timeline my-2"
      }, {
        marker: _withCtx((slotProps) => [
          _createVNode("span", {
            class: "custom-marker shadow-2",
            style: {
            backgroundColor: _ctx.iconBackgroundColor(slotProps.item.claimStatus)
          }
          }, [
            _createVNode(_component_Icons, {
              name: _ctx.iconTimeline(slotProps.item.claimStatus)
            }, null, 8, ["name"])
          ], 4)
        ]),
        content: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDate(slotProps.item.claimCreatedAt)), 1),
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("div", _hoisted_5, null, 512), [
              [_directive_sanitize_html, slotProps.item.claimDescription]
            ])
          ])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}